/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcknowledgeMessageRequest
 */
export interface AcknowledgeMessageRequest {
    /**
     * 
     */
    resume_reminders?: boolean;
}

/**
 * Check if a given object implements the AcknowledgeMessageRequest interface.
 */
export function instanceOfAcknowledgeMessageRequest(value: object): value is AcknowledgeMessageRequest {
    return true;
}

export function AcknowledgeMessageRequestFromJSON(json: any): AcknowledgeMessageRequest {
    return AcknowledgeMessageRequestFromJSONTyped(json, false);
}

export function AcknowledgeMessageRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeMessageRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'resume_reminders': json['resume_reminders'] == null ? undefined : json['resume_reminders'],
    };
}

export function AcknowledgeMessageRequestToJSON(json: any): AcknowledgeMessageRequest {
    return AcknowledgeMessageRequestToJSONTyped(json, false);
}

export function AcknowledgeMessageRequestToJSONTyped(value?: AcknowledgeMessageRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resume_reminders': value['resume_reminders'],
    };
}

